function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.9915 7.5H28.2336C38.7214 7.5 46.6714 13.1371 49.6289 21.3399H55V26.2978H50.76C50.843 27.0812 50.8854 27.8794 50.8854 28.6904V28.8121C50.8854 29.7251 50.8318 30.6226 50.7269 31.5017H55V36.4596H49.5267C46.4913 44.5482 38.6029 50.1316 28.2336 50.1316H10.9915V36.4596H5V31.5017H10.9915V26.2978H5V21.3399H10.9915V7.5ZM15.8117 36.4596V45.684H28.2336C35.8991 45.684 41.5941 41.9895 44.2452 36.4596H15.8117ZM45.7219 31.5017H15.8117V26.2978H45.7296C45.8405 27.1167 45.8971 27.9562 45.8971 28.8121V28.9339C45.8971 29.8096 45.8379 30.6669 45.7219 31.5017ZM28.2336 11.9402C35.9344 11.9402 41.6465 15.7322 44.2816 21.3399H15.8117V11.9402H28.2336Z",
  fill: "#F4B731"
});

var SvgDaiColor = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "5 7.5 50 42.632",
    width: 50,
    height: 42.632,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDaiColor, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/dai-color.2bd4c68d.svg";
export { ForwardRef as ReactComponent };